import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { buildUrl } from './backupSettings.service';
import { queryKeys } from './queryKeys';

export function useRunLocalBackupNowMutation() {
  const queryClient = useQueryClient();

  return useMutation(runLocalBackupNow, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.backupLocalStatus());
    },
    ...withError('Unable to run local backup'),
  });
}

async function runLocalBackupNow() {
  try {
    await axios.post(buildUrl('local', 'run'));
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to run local backup');
  }
}
